module.exports = __webpack_public_path__ + "img/kasko-osago.06392a9.png";